import { NEWSLETTER_SUBSCRIBE } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export const postNewsletterSubscribe = async (email, language, languageRootPath, ymeInterests, racingInterests) => {
    const answer = await Network.post(NEWSLETTER_SUBSCRIBE, {
        email,
        language,
        languageRootPath,
        ymeInterests,
        racingInterests,
    });
    return answer;
};
